import styled from 'styled-components';

import { spacing, colors, transitions } from '../../../../../styles/theme';
import BaseButton from '../../../../ui/Button';

export const Container = styled.div`
  padding: ${spacing('4')} ${spacing('8')};
  max-width: 400px;

  a {
    text-decoration: none;
    color: ${colors('primary.base')};
  }
`;

export const Button = styled(BaseButton)`
  padding: 12px ${spacing('6')};
  margin: ${spacing('4')} auto;
  display: block;
`;

export const ButtonCancel = styled.button`
  padding: ${spacing('2')} ${spacing('4')};
  font-size: 16px;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  transition: ${transitions('fast')};

  &:hover {
    color: ${colors('accent.base')};
    transition: ${transitions('fast')};
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${spacing('4')};
  width: 100%;

  button {
    margin: 0;
  }

  button + button {
    margin-top: ${spacing('2')};
  }
`;

export const ButtonBack = styled.button``;
